import { render, staticRenderFns } from "./terms-use.vue?vue&type=template&id=be290350&scoped=true&"
import script from "./terms-use.vue?vue&type=script&lang=js&"
export * from "./terms-use.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be290350",
  null
  
)

export default component.exports